import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemSignatureValue
} from "../../report-design-item";

@Pipe({
  name: "asSignatureValue",
  standalone: false
})
export class ReportItemConfigAsSignatureValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemSignatureValue {
    return <ReportDesignItemSignatureValue>value;
  }
}
